import {
	createRootRoute,
	createRouter,
	createRoute,
	AnyRoute,
} from '@tanstack/react-router';

import config from '@/config';
import { basepath } from '@/constants';
import { Home } from './home/Home';
import { IssueView } from '@/views/issue/Issue';

import { useAuth } from '../../views/home/auth/Authentication.hooks';
import Drafts from '../../views/drafts/Drafts';
import { NotFound, RootRouteComponent } from '@/views/RootRoute';
import { issueSearchSchema } from '@/views/issue/Issue.hooks';

/* Routes declaration */

const rootRoute = createRootRoute({
	component: RootRouteComponent,
});

const indexRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: '/',
	component: Home,
});

const issueRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: AuthIssue,
	validateSearch: issueSearchSchema,
	path: 'issues/$id',
});

const issueArticleRoute = createRoute({
	getParentRoute: () => issueRoute,
	component: AuthIssue,
	validateSearch: issueSearchSchema,
	path: '$articleId',
});

const draftsRoute = createRoute({
	getParentRoute: () => issueRoute,
	component: Drafts,
	path: 'drafts',
});

/* END of routes declaration */

const routes: Array<AnyRoute> = [indexRoute, issueRoute, issueArticleRoute];

if (config?.app?.admin) {
	routes.push(draftsRoute);
}

const routeTree = rootRoute.addChildren(routes);

export const router = createRouter({
	routeTree,
	basepath,
	defaultNotFoundComponent: NotFound,
});

function AuthIssue() {
	useAuth({ redirect: true });
	return (
		<>
			<IssueView />
		</>
	);
}
